import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Observable } from "rxjs";
import { SystemSetting } from './configuration.model';
import { HttpClient } from '@angular/common/http';
import {Http} from '@angular/http'
import {map} from 'rxjs/operators';


/**
 * @description
 * @class
 */
@Injectable()
export class systemsettingsserviceService {

  constructor(private httpclient: HttpClient,
    private http: Http) {
    
  }

  public hasStateIdentifier: boolean;
  public stateIdentifiers: string[];

  public getStateIdentifier(): boolean{
    return this.hasStateIdentifier;
  }

  public getStateIdesntifierValues(): string[]{
    return this.stateIdentifiers;
  }

  getSysytemSettings(state: string): Observable<SystemSetting[]> {
    
    return this.httpclient.get<SystemSetting[]>(`api/SystemSettings`, {
      params: { state: state }
  });
}

}
